import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData, graphql } from '@packages/gql/generated/shopping';
import type { GlycerinService } from '@packages/tracking';

const GetGlycerinServicesFragment = graphql(/* GraphQL */ `
  fragment GetGlycerinServicesFragment on APlus {
    clusters {
      label
      services {
        gratis
        name
        price
        preselected
      }
    }
  }
`);

const GetGlycerinServicesCurrencyFragment = graphql(/* GraphQL */ `
  fragment GetGlycerinServicesCurrencyFragment on ProductPrice {
    currency
  }
`);

export type GetGlycerinServicesProps = {
  aplus: FragmentType<typeof GetGlycerinServicesFragment> | null;
  price: FragmentType<typeof GetGlycerinServicesCurrencyFragment>;
};

export const getGlycerinServices = ({ aplus, price }: GetGlycerinServicesProps) => {
  if (!aplus) return { services: undefined };

  const { clusters } = getFragmentData(GetGlycerinServicesFragment, aplus);
  const { currency } = getFragmentData(GetGlycerinServicesCurrencyFragment, price);

  if (clusters.length === 0) return { services: undefined };

  const services: GlycerinService[] = [];

  clusters.forEach(
    (cluster) =>
      cluster?.services.forEach((service) => {
        services.push({
          currency,
          displayedPrice: service.gratis || !service.price ? 0 : Math.round(service.price * 100),
          serviceType: cluster.label,
          name: service.name || '',
          quantity: service.preselected ? 1 : 0,
        });
      }),
  );

  return {
    services,
  };
};
